import styled from "styled-components";

export const CardWrapper = styled.div`
  padding-bottom: var(--fd-space-space-1);
`;
